<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->

<div [config]="preloaderService.getLoadingConfig(loaderKey)" [suiIsLoading]="loaderKey" class="dialog-content preloader-wrapper">
    <div class="siklu-mat-dialog-title" matDialogTitle>
        <h4>
            {{ (isSikluUser ? 'userManagement.popups.createOrEditSikluLabel' : 'userManagement.popups.createOrEditLabel') | translate }}
        </h4>
        <button matDialogClose windeClose>
            <sui-svg-icon icon="cross"/>
        </button>
    </div>

    <div *ngIf="user" class="siklu-mat-dialog-body" matDialogContent>
        <winde-alert-error></winde-alert-error>

        <div class="row">
            <div class="control col-12">
                <div class="control-label">{{ 'userManagement.popups.login' | translate }}</div>
                <sui-string-component [config]="user.login"></sui-string-component>
            </div>
        </div>

        <div class="row">
            <div class="control col-12">
                <div class="control-label">{{ 'userManagement.popups.password' | translate }}</div>
                <sui-password-component [config]="user.password"></sui-password-component>
            </div>
            <div class="password-strength col-12">
                <winde-password-strength-bar [passwordToCheck]="user.password.value"></winde-password-strength-bar>
            </div>
            <div class="control col-12">
                <div class="control-label">{{ 'userManagement.popups.confirmPassword' | translate }}</div>
                <sui-password-component [config]="passwordConfirmationField"></sui-password-component>
            </div>
            <div class="control col-12">
                <div class="control-label">{{ 'userManagement.popups.firstName' | translate }}</div>
                <sui-string-component [config]="user.firstName"></sui-string-component>
            </div>
            <div class="control col-12">
                <div class="control-label">{{ 'userManagement.popups.lastName' | translate }}</div>
                <sui-string-component [config]="user.lastName"></sui-string-component>
            </div>
            <div *ngIf="!isSikluUser" class="control col-12">
                <div class="control-label">
                    {{ 'userManagement.popups.profiles' | translate }}
                    <small>{{ 'userManagement.popups.profileChangesMessage' | translate }}</small>
                </div>
                <sui-radio-group-component [config]="authorityField"></sui-radio-group-component>
            </div>
        </div>
    </div>
    <div class="siklu-mat-dialog-footer" matDialogActions>
        <button matDialogClose windeTransparent>
            <sui-svg-icon icon="cross"/>
            {{ 'entity.action.cancel' | translate }}
        </button>
        <button (click)="save()" *ngIf="user" windeGreen>
            <sui-svg-icon icon="save"/>
            {{ 'entity.action.save' | translate }}
        </button>
    </div>
</div>
